/**
 * Simple cross-component event emitter for Expo.
 * Replaces window.dispatchEvent(new Event('...')) from Next.js.
 */

type Listener = (data?: any) => void

const listeners: Record<string, Set<Listener>> = {}
const debounceTimers: Record<string, ReturnType<typeof setTimeout>> = {}

export const appEvents = {
  emit(event: string, data?: any) {
    listeners[event]?.forEach(fn => fn(data))
  },
  /** Emit with debounce — collapses rapid fires into one call */
  emitDebounced(event: string, data?: any, ms = 500) {
    if (debounceTimers[event]) clearTimeout(debounceTimers[event])
    debounceTimers[event] = setTimeout(() => {
      listeners[event]?.forEach(fn => fn(data))
    }, ms)
  },
  on(event: string, fn: Listener) {
    if (!listeners[event]) listeners[event] = new Set()
    listeners[event].add(fn)
    return () => { listeners[event]?.delete(fn) }
  },
}
